import React from 'react';
import classes from './Layout.module.css';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

const Layout = props => {
    return (
        <React.Fragment>
            <main className={classes.Content}>
                <NotificationContainer />
                {props.children}
            </main>
        </React.Fragment>
    );
}

export default Layout;